export const BORDER_COLOR = '#e0e0e0';

export default { BORDER_COLOR };
